export const MODAL_DELETE_EXTRA_ACTIVITY_TEXT = {
	itemLabel: 'extra activity',
	extraLabel: 'It may affect pay calculations.',
	title: 'Are you sure you want to delete this extra activity?',
};
